import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M4.067 7.27c.583-3.417 3.549-6.02 7.125-6.02a7.22 7.22 0 0 1 6.063 3.302C20.3 4.6 22.75 7.09 22.75 10.15c0 3.09-2.498 5.599-5.584 5.599H5.621a4.377 4.377 0 0 1-4.371-4.383 4.38 4.38 0 0 1 2.817-4.098m7.125-4.52c-2.966 0-5.408 2.263-5.7 5.165a.75.75 0 0 1-.565.653 2.88 2.88 0 0 0-2.177 2.799 2.877 2.877 0 0 0 2.871 2.883h11.545a4.09 4.09 0 0 0 4.084-4.1 4.09 4.09 0 0 0-4.36-4.09.75.75 0 0 1-.705-.38 5.72 5.72 0 0 0-4.993-2.93"
      clipRule="evenodd"
    />
    <path d="M8 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0M17 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 22a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16 22a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
  </>
);

const Weather41 = Icon('weather-41', svgContents);

export default Weather41;
